import { render, staticRenderFns } from "./GoodsclassBody.vue?vue&type=template&id=798db544&scoped=true"
import script from "./GoodsclassBody.vue?vue&type=script&lang=js"
export * from "./GoodsclassBody.vue?vue&type=script&lang=js"
import style0 from "./GoodsclassBody.vue?vue&type=style&index=0&id=798db544&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "798db544",
  null
  
)

export default component.exports